document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collapsible-text-wrapper').forEach(function(wrapper) {
    const text = wrapper.querySelector('.collapsible-text');
    const readMore = wrapper.querySelector('.read-more-text');

    if (!text) return;

    // see if read more toggle is enabled or not 
    const readMoreEnabled = wrapper.dataset.readMoreEnabled === 'true';
    if (!readMoreEnabled) {
      text.style.maxHeight = 'none';
      text.style.overflow = 'visible';
      if (readMore) readMore.style.display = 'none';
      return;
    }

    // Collapse text if it exceeds 8 lines
    const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
    const maxHeight = lineHeight * 12;

    if (text.scrollHeight <= maxHeight) {
      readMore.style.display = 'none';
      text.style.maxHeight = 'none';
      text.style.overflow = 'visible';
      return;
    } else {
      readMore.style.display = 'inline-block';
      text.style.maxHeight = maxHeight + 'px';
      text.style.overflow = 'hidden';
    }

    // Skip duplicate listeners
    if (readMore.dataset.bound === 'true') return;
    readMore.dataset.bound = 'true';

    readMore.addEventListener('click', function() {
      const isExpanded = text.classList.toggle('expanded');
      wrapper.classList.toggle('expanded', isExpanded);

      if (isExpanded) {
        text.style.maxHeight = text.scrollHeight + 'px';
        text.style.overflow = 'visible';
        readMore.textContent = 'Read Less';
      } else {
        text.style.maxHeight = maxHeight + 'px';
        text.style.overflow = 'hidden';
        readMore.textContent = 'Read More';
      }
    });
  });
});
